module.exports = __webpack_public_path__ + "fonts/Monotype  - Neue Plak Regular.1e8b9b0.ttf";